import { useState } from "react";
import { useTranslation } from "react-i18next";
import PageWrapper from "@/components/PageWrapper.tsx";
import IconInfoCircle from "@/assets/icons/info-circle-linear.svg?react";
import VibratingButton from "@/components/base/button/VibratingButton.tsx";
import { useGetPartners } from "./api";
import PartnerList from "./components/PartnerList.tsx";
import LoyaltyQRButton from "./components/LoyaltyQRButton.tsx";
import PartnerFAQSheet from "./components/PartnerFAQSheet.tsx";

export default function PartnersPage() {
  const { t } = useTranslation();
  const { data: partners = [], isLoading: isPartnersLoading } = useGetPartners();
  const [isFAQOpen, setIsFAQOpen] = useState(false);

  return (
    <PageWrapper backPath="/">
      <div
        className="overflow-y-auto bg-dark"
        style={{
          height:
            "calc(var(--tg-viewport-height, 100dvh) - var(--safe-area-inset-top, 0px) - var(--safe-area-inset-bottom, 0px))",
        }}
      >
        <div
          className="container pt-4 pb-2 z-30 bg-dark flex items-center justify-between gap-3"
          style={{ position: "sticky", top: 0 }}
        >
          <h1 className="text-xl font-bold text-white leading-130">
            {t("partners")}
          </h1>
          <VibratingButton
            onClick={() => setIsFAQOpen(true)}
            vibrationType="selection"
            aria-label={t("partners_faq_title") || "FAQ"}
            className="shrink-0 flex items-center gap-1.5 px-3 py-1.5 -mr-1 rounded-full bg-white/[0.04] border border-white/[0.08] active:bg-white/[0.08] transition-colors"
          >
            <IconInfoCircle className="size-4 text-orange-100" />
            <span className="text-sm font-semibold text-white leading-none">
              FAQ
            </span>
          </VibratingButton>
        </div>

        <div className="container pb-24">
          <PartnerList partners={partners} isLoading={isPartnersLoading} />
        </div>
      </div>

      <LoyaltyQRButton />

      <PartnerFAQSheet
        isOpen={isFAQOpen}
        onClose={() => setIsFAQOpen(false)}
      />
    </PageWrapper>
  );
}
